import * as React from "react";
import type { SVGProps } from "react";
const SvgAmOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    width="1em"
    height="1em"
    role="img"
    focusable={false}
    {...props}
  >
    <path
      fill="#1D1D1D"
      fillRule="evenodd"
      d="M8 5.334a2.667 2.667 0 1 0 0 5.333 2.667 2.667 0 0 0 0-5.333M4 8a4 4 0 1 1 8 0 4 4 0 0 1-8 0M8 0c.368 0 .667.299.667.667V2a.667.667 0 0 1-1.334 0V.667C7.333.299 7.632 0 8 0M8 13.334c.368 0 .667.298.667.667v1.333a.667.667 0 0 1-1.334 0V14c0-.369.299-.667.667-.667M2.341 2.343c.26-.26.683-.26.943 0l.947.946a.667.667 0 1 1-.943.943l-.947-.947a.667.667 0 0 1 0-.942M11.768 11.768c.26-.26.683-.26.943 0l.947.947a.667.667 0 0 1-.943.943l-.947-.947a.667.667 0 0 1 0-.943M0 8c0-.368.299-.666.667-.666H2a.667.667 0 0 1 0 1.333H.667A.667.667 0 0 1 0 8.001M13.333 8c0-.368.299-.666.667-.666h1.333a.667.667 0 1 1 0 1.333H14a.667.667 0 0 1-.667-.666M4.23 11.768c.26.26.26.683 0 .943l-.946.947a.667.667 0 0 1-.943-.943l.947-.947c.26-.26.682-.26.943 0M13.658 2.343c.26.26.26.682 0 .942l-.947.947a.667.667 0 1 1-.943-.943l.947-.946c.26-.26.682-.26.943 0"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgAmOutlined;
